import {Input, InputWrapperDiv} from "../../../../../../../../components/ui/Input";
import React, {useState} from "react";
import Select from "react-select";
import select_styles from "../../../../../../../../layouts/elements";
import {Button} from "../../../../../../../../components/ui/Button";
import { useTranslation } from "react-i18next";


export default function CooperationPopupForm({cooperationsWithList, cancelBtn, saveBtn, handlePopup}) {
    const { t } = useTranslation();
    const [selTypeForm, setSelTypeForm] = useState("1")
    const [selectedValue, setSelectedValue] = useState("")
    const [newValue, setNewValue ] = useState("")

    const OPTIONS = [
        { value: "1", label: t("popups.tech_info_add_people.search_in_list") },
        { value: "2", label: t("popups.tech_info_add_people.create_new") },
    ];

    const changeHandler = (value, opt) => {
        if (opt === 'radio-button') {
            setSelTypeForm(value)
            setNewValue("")
            setSelectedValue("")
        } else if (opt === "formOpt") { // selected
            setSelectedValue(value)
        } else { // added
            setNewValue(value)
        }
    }

    const handleClickFactory = (e) => {
        const buttonName = e.target.name
        if (buttonName === 'save') {
            if (!newValue && !selectedValue) return

            let newEntry = selectedValue

            if (selTypeForm === "2") {
                newEntry = {value: newValue, label: newValue, pk: null}
            }
            return handlePopup({
                type: "save",
                context_data: {
                    selFormOption: selTypeForm,
                    newValue: newEntry
                }
            })
        }
        if (buttonName === 'cancel') {
            return handlePopup({type: "cancel"})
        }
    };

    return (<>
        <div className="row mb-3">
            <Input
                name="direction_manager"
                type={"radio"}
                options={OPTIONS}
                value={selTypeForm}
                style={{minWidth: "250px", width: "50%", marginLeft: "10px"}}
                classNameDiv='col-sm-6'
                onChange={val => changeHandler(val, "radio-button")}
                required
            />
        </div>
        {selTypeForm === "1"
            ? <div>
                <Select
                    options={cooperationsWithList}
                    value={selectedValue}
                    onChange={val => changeHandler(val, "formOpt")}
                    styles={select_styles}
                    isSearchable={true}
                    unstyled
                />
            </div>
            : (<>
                <div className='row pb-2'>
                    <InputWrapperDiv>
                        <Input
                            placeholder='Name *'
                            name='name_cn'
                            value={newValue}
                            onChange={val => changeHandler(val)}
                            readOnly={true}
                        />
                    </InputWrapperDiv>
                </div>
            </>)
        }
        <Button name="save" onClick={(e) => handleClickFactory(e)}
                variant="round" bWidth="small" styling="plain" className='mx-3' proposueButton="green">{saveBtn}
        </Button>
        <Button name="cancel" onClick={(e) => handleClickFactory(e)}
                variant="round" bWidth="small" styling="bordered" className='mx-3'>{cancelBtn}
        </Button>
    </>)
}